<template>
    <div id="pageTable" class="mainView">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-btn color="success" dark slot="activator" @click="downloadExcel">엑셀다운로드</v-btn>

                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-menu
                                    ref="menu"
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    min-width="290px"
                                    :return-value.sync="tempDate"
                            >
                                <v-text-field
                                        slot="activator"
                                        label="운행날짜"
                                        v-model="tempDate"
                                        prepend-icon="event"
                                        readonly
                                ></v-text-field>
                                <v-date-picker v-model="tempDate" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                    <v-btn flat color="primary" @click="applyAggrDate(tempDate)">OK</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-toolbar>

                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[10,25,50]"
                                    class="elevation-1"
                                    item-key="driverUsageId"
                                    must-sort
                                    :total-items="totalItems"
                                    :pagination.sync="pagination"
                                    >

                                <template slot="items" slot-scope="props">
                                    <td class="text-sm-center">{{ props.item.aggrDate }}</td>
                                    <td class="text-sm-center">{{ props.item.settDate }}</td>
                                    <td class="text-sm-center">{{ props.item.driverUsageId }}</td>
                                    <td class="text-sm-center">{{ props.item.passengerId1 }}</td>
                                    <td class="text-sm-center">{{ props.item.passengerId2 }}</td>
                                    <td class="text-sm-center">{{ props.item.driverName }}</td>
                                    <td class="text-sm-center">{{ props.item.bankName }}</td>
                                    <td class="text-sm-center">{{ props.item.accountNumber }}</td>
                                    <td class="text-sm-center">{{ props.item.accountHolder }}</td>
                                    <td class="text-sm-center">{{ props.item.totalFee }}</td>
                                    <td class="text-sm-center">{{ props.item.serviceFee }}</td>
                                    <td class="text-sm-center">{{ props.item.settFee }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
  import VWidget from '@/components/VWidget';
  import Util from '@/util';

  export default {
    components: {
      VWidget, Util
    },
    data () {
      return {
        pagination: {
          descending: true,
          rowsPerPage: 10,
          page: 1,
          sortBy: 'driverUsageId'
        },
        totalItems: 0,
        tempDate: null,
        aggrDate: null,
        menu: false,
        search: '',
        complex: {
          headers: [
            {
              text: '운행날짜',
              value: 'aggrDate',
              align: 'center',
              sortable: false
            },
            {
              text: '정산날짜',
              value: 'settDate',
              align: 'center',
              sortable: false
            },
            {
              text: '승차 아이디 (승차번호)',
              value: 'driverUsageId',
              align: 'center'
            },
            {
              text: '승객 1',
              value: 'passengerId1',
              align: 'center'
            },
            {
              text: '승객 2',
              value: 'passengerId2',
              align: 'center'
            },
            {
              text: '이름',
              value: 'driverName',
              align: 'center'
            },
            {
              text: '은행',
              value: 'bankName',
              align: 'center'
            },
            {
              text: '계좌',
              value: 'accountNumber',
              align: 'center',
              sortable: false
            },
            {
              text: '예금주',
              value: 'accountHolder',
              align: 'center'
            },
            {
              text: '최종요금 (운행요금+추가요금)',
              value: 'totalFee',
              align: 'center'
            },
            {
              text: '추가수익 (서비스 이용료)',
              value: 'serviceFee',
              align: 'center'
            },
            {
              text: '최종 정산금',
              value: 'settFee',
              align: 'center'
            }
          ],
          items: []
        },
      };
    },
    watch: {
        pagination: {
            handler () {
                this.banbanCreated();
            },
            deep: true
        }
    },
    mounted () {
      for (let i = 0; i < this.$parent.$children.length; i++) {
        if (this.$parent.$children[i].chkAutoReload != null) {
          this.$parent.$children[i].chkAutoReload();
        }
      }

      this.initDate();
    },
    methods: {
      initDate () {
        let date = moment().subtract(2, 'days').format('YYYY-MM-DD');
        this.tempDate = date;
        this.aggrDate = date;
      },
      banbanCreated () {
        if(!this.verifyAggrDate()) return;

        const parameters = {
          method: 'searchSettlementDetails',
          pageNum: this.pagination.page - 1,
          pageSize: this.pagination.rowsPerPage,
          sortName: this.pagination.sortBy,
          order: this.pagination.descending == true ? 'desc' : 'asc',
          aggrDate: this.aggrDate
        };

        this.$store.dispatch('banbanAPI', parameters)
          .then(({ data }) => {
            top.getApp.progress.dialog = false;
            this.complex.items = data.content;
            this.totalItems = data.totalElements;
          })
          .catch((error) => {
            if (top.getApp.commonError == null) {
              alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            }
            top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      },
      applyAggrDate (tempDate) {
        this.$refs.menu.save(tempDate);
        this.aggrDate = tempDate;

        this.banbanCreated();
      },
      downloadExcel () {
        if(!this.verifyAggrDate()) return;

        const parameters = {
          method: 'downloadSettlementDetails',
          responseType: 'blob',
          aggrDate: this.aggrDate
        };

        this.$store.dispatch('banbanAPI', parameters)
          .then((res) => {
            top.getApp.progress.dialog = false;
            Util.downloadFile(res);
          })
          .catch((error) => {
            if (top.getApp.commonError == null) {
              alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
            }
            top.getApp.commonError = null;
            top.getApp.progress.dialog = false;
          });
      },
      verifyAggrDate () {
        if(!this.aggrDate) {
          alert('운행날짜를 선택해 주세요.');
          return false;
        }
        return true;
      }
    }
  };

</script>



// WEBPACK FOOTER //
// src/pages/settlement/SettlementDetails.vue